<template>
    <div>
        <div class="chartCol1" >
            <Row class="patentialRow" v-for="(item,index) in data" :key="index">
            <Col span="3"><span>{{lang=='zh'?item.scopeType:item.enScopeType}}</span></Col>
            <Col span="4">
                <div class="potentialBox" :class="index==0||index==1?'potentialBoxBackground1':'potentialBoxBackground4'" @click="showInfoClick(item,1,index)">{{item.achNormal1}}</div>
            </Col>
            <Col span="4">
                <div class="potentialBox" :class="index==0||index==1?'potentialBoxBackground1':'potentialBoxBackground4'" @click="showInfoClick(item,2,index)">{{item.achNormal2}}</div>
            </Col>
            <Col span="4">
                <div class="potentialBox" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5'" @click="showInfoClick(item,3,index)">{{item.achNormal3}}</div>
            </Col>
            <Col span="4">
                <div class="potentialBox" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5'" @click="showInfoClick(item,4,index)">{{item.achNormal4}}</div>
            </Col>
            <Col span="4">
                <div class="potentialBox" :class="index==0?'potentialBoxBackground2':index==1?'potentialBoxBackground3':'potentialBoxBackground5'" @click="showInfoClick(item,5,index)">{{item.achNormal5}}</div>
            </Col>
            </Row>
            <Row class="patentialRow">
            <Col span="3"></Col>
            <Col span="4">{{$t('PB_Requires_Improvement')}}</Col><!-- 需要改善 -->
            <Col span="4">{{$t('PB-Typically_Meets')}}</Col><!-- 部分达标 -->
            <Col span="4">{{$t('PB-Achieved')}}</Col><!-- 达到要求 -->
            <Col span="4">{{$t('PB-Exceeds')}}</Col><!-- 超越要求 -->
            <Col span="4">{{$t('PB-Exceptional')}}</Col><!-- 优秀出色 -->
            </Row>
        </div>
        <Modal v-model="showinfoModal" title="员工信息" width="400px">
            <div class="modalListBox">
            <List :header="$t('Name')" border size="small">
                <ListItem v-for="(item, index) in dataListName" :key="index">
                <ListItemMeta>
                    <template slot="title">
                    <div style="display:flex;align-items:center">
                        {{ item.userName}}<Icon v-if="item.serialnumber == '0001' || item.serialnumber == '1002'" type="md-star" size="12" color="#ffb400"/>
                    </div>
                    </template>
                </ListItemMeta>
                <template slot="action">
                    <li><span style="color:#459846" @click="moredetil(item)"><!-- 更多 -->{{$t('Select_More')}}</span></li>
                </template>
                </ListItem>
            </List>
            </div>
            <Spin size="large" fix v-if="modalSpinShow"></Spin>
            <div slot="footer">
            <Button @click="showinfoModal = false">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
            dataListName:[],
            showinfoModal:false,
            modalSpinShow:false,
            data:[],
            allData:[]
        }
    },
    computed:{
      lang(){
        return this.$store.getters.selectLangeData
      }
    },
    methods:{
        showInfoClick(item,colIndex,rowIndex) {
            this.showinfoModal=true
            this.modalSpinShow=true
            let obj={
              allData:this.allData,
              wholeScore:colIndex,
              potentialScore:item.scopeType
            }
            axios.post('/achReport/selectFifteenTableLeftData', obj).then(res => {
              this.modalSpinShow=false
              if (res) {
                this.dataListName =res
              }
            });
            
        },
        moredetil(row){
          this.$router.push({ path: '/090E24C0B112F54B073978E64390DDE1/A3FFBEBFDB713E27', 
          query: { id:this.$route.query.id ,beEnd:this.$route.query.beEnd,serialnumber:row.serialnumber} })
          // query: { serialnumber:row.serialnumber} })
        }
    }
}
</script>


<style lang="less" scoped>
.patentialRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  span {
    display: block;
    text-align: right;
    margin-right: 20px;
  }
}
.potentialBox {
  width: 96%;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  line-height: 120px;
  text-align: center;
  cursor: pointer;
  font-size: 22px;
}
.potentialBox:hover {
  opacity: 0.5;
}
.potentialBoxBackground1 {
  background-image: linear-gradient(
    45deg,
    #dfdfdf 25%,
    white 0,
    white 50%,
    #dfdfdf 0,
    #dfdfdf 75%,
    white 0
  );
  background-size: 6px 6px;
}
.potentialBoxBackground2 {
  background-color: rgb(0, 50, 30);
  color: white;
}
.potentialBoxBackground3 {
  background-color: rgb(23, 177, 105);
}
.potentialBoxBackground4 {
  background-color: rgb(255, 180, 0);
}
.potentialBoxBackground5 {
  background-color: rgb(180, 145, 50);
}
.modalListBox {
  max-height: 500px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchAssessComponentProportion.vue